import React from 'react'
import { Link } from 'react-router-dom'
import { FormGroup } from 'reactstrap'
import { SocialLinksProp } from '../../../../../Types/Others.type'
import { H6, LI, P, UL } from '../../../../../AbstractElements'
import { CreateAccount } from '../../../../../Utils/Constants'
import { socialLinksData } from '../../../../../Data/Pages/Others'

export default function SocialLinks({ logtext, btntext, onClick }: SocialLinksProp) {
    return (
        <>
         
            <P className="mt-4 mb-0 text-center">
                {logtext ? logtext : "Don't have account?"}
                {!logtext && !btntext ? (
                    <Link className="ms-2" to={`${process.env.PUBLIC_URL}/authentication/register_simple`}>{CreateAccount}</Link>
                ) : (
                    <Link to={`${process.env.PUBLIC_URL}/authentication/login_simple`} className='ms-2' onClick={onClick}>{btntext}</Link>
                )}
            </P>
        </>
    )
}
